export default __webpack_public_path__ + "static/media/infoImg2.6edcb86a.png";